"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateModesList = exports.Comparisons = void 0;
exports.Comparisons = [
    "is",
    "is_not",
    "is_empty",
    "is_not_empty",
    "contains",
    "not_contains",
    "is_equal_to",
    "is_not_equal_to",
    "is_greater_than",
    "is_less_than",
    "is_equal_or_greater_than",
    "is_equal_or_less_than",
    "is_any_of",
    "is_none_of",
    "is_exactly",
    "has_all_of",
    "has_any_of",
    "has_none_of",
    "is_empty",
    "is_not_empty",
    "is_within",
    "is_not_within",
    "is_before",
    "is_after",
    "is_on_or_before",
    "is_on_or_after",
    "file_name_contains",
    "file_type_is",
    "is_overdue",
    "is_not_overdue",
    "all_items_resolved",
    "not_all_items_resolved",
    "percent_complete_greater_than",
    "percent_complete_less_than",
    "is_completed",
    "is_not_completed",
    "never",
];
exports.DateModesList = [
    "today",
    "tomorrow",
    "yesterday",
    "one_week_ago",
    "one_week_from_now",
    "one_month_ago",
    "one_month_from_now",
    "one_year_ago",
    "one_year_from_now",
    "exact_date",
    "exact_date_time",
    "date_range",
    "past_week",
    "past_month",
    "past_year",
    "next_week",
    "next_month",
    "next_year",
    "next_number_of_days",
    "past_number_of_days",
];
